"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _commonI18n = require("@mmc/common-i18n");

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _vehicleCompare = _interopRequireDefault(require("../styles/vehicle-compare.css"));

var _compareSelectBoxes = _interopRequireDefault(require("./compare-select-boxes"));

var _option;

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;
var CHANGE_DELETE_VEHICLE = {
  UPDATE_VEHICLE: 'change',
  DELETE_VEHICLE: 'delete'
};

var ModelSelector = function ModelSelector(_ref) {
  var _option2, _option3;

  var theme = _ref.theme,
      vehicleSelectedList = _ref.vehicleSelectedList,
      actions = _ref.actions,
      numberOfColumns = _ref.numberOfColumns,
      addVehicleLabel = _ref.addVehicleLabel,
      changeVehicleLabel = _ref.changeVehicleLabel,
      deleteVehicleLabel = _ref.deleteVehicleLabel,
      config = _ref.config;

  var updateSelected = function updateSelected(vehicleCode, modelCode, index) {
    actions.vehicleUpdateModelList(vehicleCode, modelCode, index);
  };

  var updateDeleteAction = function updateDeleteAction(params) {
    var event = params.event,
        index = params.index;

    if (event.target.value === CHANGE_DELETE_VEHICLE.UPDATE_VEHICLE) {
      actions.updateCurrentOrder(index);
      actions.showHideVehicleList({
        stage1: false,
        stage2: true,
        overlayDialog: true
      });
    } else if (event.target.value === CHANGE_DELETE_VEHICLE.DELETE_VEHICLE) {
      actions.vehicleDelete(index);
    }

    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'comparison_edit',
        comparison: {
          dropdown: event.target.value
        }
      });
    }

    event.target.value = '';
  };

  var numberOfMockColumn = numberOfColumns - vehicleSelectedList.length;
  var activeCardIndex = 0;

  var handleClick = function handleClick(indexLength, index) {
    actions.updateCurrentOrder(indexLength);
    actions.showHideVehicleList({
      stage1: false,
      stage2: true,
      overlayDialog: true
    });
    activeCardIndex = index + 1; // set active card index to the index of the selected card
  };

  function modelProperty(vehicle, modelCode, property) {
    var model = vehicle.models.find(function (models) {
      return models.code === modelCode;
    });

    if (property === 'name') {
      return model.name;
    }

    if (property === 'price') {
      var _model$price;

      return model == null ? void 0 : (_model$price = model.price) == null ? void 0 : _model$price.value;
    }
  }

  var selectedModelCodes = [];

  if (vehicleSelectedList && vehicleSelectedList.length) {
    selectedModelCodes = vehicleSelectedList.map(function (vehicle) {
      return vehicle.value;
    });
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _vehicleCompare["default"].modelSelectorWrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    key: Math.random(),
    className: _vehicleCompare["default"].modelSelectorGraphql + " " + _vehicleCompare["default"].modelSelectorContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.row + " " + _vehicleCompare["default"].noMargin + " " + _vehicleCompare["default"].forceWidth
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-sm-1'] + " " + _vehicleCompare["default"].noPadding
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-sm-10'] + " " + _vehicleCompare["default"].noPadding + " " + _vehicleCompare["default"].forceWidth
  }, /*#__PURE__*/_react["default"].createElement("div", {
    key: Math.random(),
    className: _vehicleCompare["default"].fieldsContainer
  }, vehicleSelectedList.slice(0, numberOfColumns).map(function (vehicle, index) {
    var _vehicle$vehicleImage, _vehicle$vehicleImage2, _vehicle$price, _vehicle$price2, _vehicle$price2$displ;

    return /*#__PURE__*/_react["default"].createElement("div", {
      key: Math.random(),
      className: _vehicleCompare["default"].fieldsSection
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.headingFive + " " + _vehicleCompare["default"].imageSelectContainer
    }, /*#__PURE__*/_react["default"].createElement("img", {
      className: _vehicleCompare["default"].vehiclePic,
      src: vehicle == null ? void 0 : (_vehicle$vehicleImage = vehicle.vehicleImage) == null ? void 0 : _vehicle$vehicleImage.image,
      alt: vehicle == null ? void 0 : (_vehicle$vehicleImage2 = vehicle.vehicleImage) == null ? void 0 : _vehicle$vehicleImage2.altText
    }), /*#__PURE__*/_react["default"].createElement("select", {
      className: _vehicleCompare["default"].editSelect,
      onChange: function onChange(event) {
        return updateDeleteAction({
          event: event,
          vehicle: vehicle,
          index: index
        });
      }
    }, _option || (_option = /*#__PURE__*/_react["default"].createElement("option", {
      hidden: true,
      selected: true,
      value: ""
    }, "\xA0")), _option2 || (_option2 = /*#__PURE__*/_react["default"].createElement("option", {
      value: "change"
    }, changeVehicleLabel)), _option3 || (_option3 = /*#__PURE__*/_react["default"].createElement("option", {
      value: "delete"
    }, deleteVehicleLabel)))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _vehicleCompare["default"].textDropdownContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _vehicleCompare["default"].vehicleInfoContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _vehicleCompare["default"].selectedVehicleDetails
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: _vehicleCompare["default"].selectedVehicleName
    }, vehicle.name), /*#__PURE__*/_react["default"].createElement("p", {
      className: _vehicleCompare["default"].selectedModelName
    }, modelProperty(vehicle, vehicle.value, 'name'))), (vehicle == null ? void 0 : (_vehicle$price = vehicle.price) == null ? void 0 : _vehicle$price.displayValue) && /*#__PURE__*/_react["default"].createElement("div", {
      className: _vehicleCompare["default"].pricingDetails
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: _vehicleCompare["default"].pricingDetailsFrom
    }, vehicle == null ? void 0 : (_vehicle$price2 = vehicle.price) == null ? void 0 : (_vehicle$price2$displ = _vehicle$price2.displayValue) == null ? void 0 : _vehicle$price2$displ.split('#')[0]), /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.headingSix + " " + _vehicleCompare["default"].selectedModelPriceName
    }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
      format: "price",
      returnZero: true,
      options: {
        value: modelProperty(vehicle, vehicle.value, 'price'),
        currency: handleNestedProp(config, 'config.currencyFormat'),
        locale: handleNestedProp(config, 'config.localeCode')
      }
    })))), /*#__PURE__*/_react["default"].createElement(_compareSelectBoxes["default"], {
      key: Math.random(),
      models: vehicle.models,
      theme: theme,
      vehicleCode: vehicle.code,
      selectedVehicleCode: vehicle.code,
      index: index,
      value: vehicle.value,
      vehicle: vehicle,
      updateSelected: updateSelected,
      selectedModelCodes: selectedModelCodes,
      config: config
    })));
  }), function () {
    var mockData = [];
    var selectName = new Set();

    var renderCards = function renderCards() {
      var _loop = function _loop(i) {
        var isBesideActiveCard = i === activeCardIndex || i === activeCardIndex - 1;
        var className = _vehicleCompare["default"].fieldsSection + " " + (isBesideActiveCard ? '' : _vehicleCompare["default"].transparent);
        mockData.push( /*#__PURE__*/_react["default"].createElement("div", {
          key: i,
          className: className
        }, /*#__PURE__*/_react["default"].createElement("button", {
          className: _vehicleCompare["default"].addVehicle + " " + (isBesideActiveCard ? _vehicleCompare["default"].active : ''),
          type: "button",
          onClick: function onClick() {
            handleClick(vehicleSelectedList.length, i);
          },
          disabled: !isBesideActiveCard
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: _vehicleCompare["default"].addVehicleText
        }, ' ', addVehicleLabel))));
      };

      for (var i = 0; i < numberOfMockColumn; i++) {
        _loop(i);
      }

      vehicleSelectedList.map(function (item) {
        selectName.add(item.name);
      });

      if (typeof window !== 'undefined' && window.dataLayer) {
        window.dataLayer.push({
          event: 'comparison_results',
          comparison: {
            nameplateCount: selectName.size,
            trimCount: vehicleSelectedList.length
          }
        });
      }
    };

    renderCards();
    return mockData;
  }())), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-sm-1'] + " " + _vehicleCompare["default"].noPadding
  }))));
};

var _default = ModelSelector;
exports["default"] = _default;